const RECENT_SEARCHES_KEY = "recentSearches"
const MAX_RECENT_ITEMS = 5

export function recentSearches() {
  return JSON.parse(localStorage.getItem(RECENT_SEARCHES_KEY)) || []
}

export function addItemToRecentSearches(value) {
  const inputValue = value.trim()
  const items = recentSearches().slice(0, MAX_RECENT_ITEMS - 1)

  if (items.includes(inputValue)) return

  if (inputValue.length > 0) {
    localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify([inputValue, ...items]))
  }
}

export function hide(elements) {
  elements.forEach((el) => el.classList.add("hidden"))
}

export function show(elements) {
  elements.forEach((el) => el.classList.remove("hidden"))
}

export function createCopyWithText(node, text) {
  const copy = node.cloneNode(true)
  copy.classList.remove("hidden")
  copy.querySelector("span").textContent = text
  return copy
}

export function openRecentSearch(form_id, event) {
  const row = event.target
  if (row.dataset.suggestionKind) captureSuggestionClicked.call(this, row)

  this.inputTarget.value = row.querySelector("span").textContent
  document.getElementById(form_id).requestSubmit()
}

function captureSuggestionClicked(row) {
  window.posthog?.capture("search_suggestion_clicked", {
    kind: row.dataset.suggestionKind,
    position: visibleSuggestionRows.call(this).indexOf(row),
    query_length: this.inputTarget.value.trim().length,
  })
}

export function fillRecentSearches() {
  const children = this.recentTilesTarget.children
  const recentSearchesTile = children[1]
  if (children.length > 2) {
    this.recentTilesTarget.replaceChildren(children[0], children[1])
  }

  recentSearches()
    .reverse()
    .forEach((text) => recentSearchesTile.after(createCopyWithText(recentSearchesTile, text)))
}

const SUGGESTIONS_ENDPOINT = "/api/search/suggestions"
const SUGGESTIONS_DEBOUNCE_MS = 150
const MIN_SUGGEST_LENGTH = 2
const SUGGESTION_HIGHLIGHT_CLASS = "text-primary"

export function suggestOnInput() {
  cancelSuggestions.call(this)
  const query = this.inputTarget.value.trim()

  if (query.length < MIN_SUGGEST_LENGTH) {
    toggleSuggestions.call(this, false)
    return
  }

  this.suggestTimer = setTimeout(() => fillSuggestions.call(this, query), SUGGESTIONS_DEBOUNCE_MS)
}

export function cancelSuggestions() {
  clearTimeout(this.suggestTimer)
  abortPendingSuggestions.call(this)
}

function abortPendingSuggestions() {
  this.suggestAbortController?.abort()
  this.suggestAbortController = null
}

export function suggestKeydown(event) {
  if (!["ArrowDown", "ArrowUp", "Enter"].includes(event.key)) return
  if (this.suggestionTilesTarget.classList.contains("hidden")) return

  const rows = visibleSuggestionRows.call(this)
  if (rows.length === 0) return

  const current = rows.findIndex((el) => el.classList.contains(SUGGESTION_HIGHLIGHT_CLASS))

  if (event.key === "Enter") {
    if (current === -1) return

    event.preventDefault()
    rows[current].click()
    return
  }

  event.preventDefault()
  const step = event.key === "ArrowDown" ? 1 : -1
  const next = (current + step + rows.length) % rows.length
  rows[current]?.classList.remove(SUGGESTION_HIGHLIGHT_CLASS)
  rows[next].classList.add(SUGGESTION_HIGHLIGHT_CLASS)
  this.inputTarget.value = rows[next].querySelector("span").textContent
}

async function fillSuggestions(query) {
  const controller = new AbortController()
  this.suggestAbortController = controller

  let groups = []
  try {
    const response = await fetch(`${SUGGESTIONS_ENDPOINT}?q=${encodeURIComponent(query)}`, {
      signal: controller.signal,
    })
    groups = (await response.json()).groups || []
  } catch (error) {
    if (error.name === "AbortError") return

    groups = []
  }

  if (this.inputTarget.value.trim() !== query) return

  const templates = this.suggestionTilesTarget.querySelectorAll("[data-suggestion-group]")
  const rendered = groups
    .filter((group) => group.suggestions.length > 0)
    .map((group) => renderSuggestionGroup(this.suggestionTilesTarget, group))
  this.suggestionTilesTarget.replaceChildren(...templates, ...rendered.filter(Boolean))
  toggleSuggestions.call(this, visibleSuggestionRows.call(this).length > 0)
}

function renderSuggestionGroup(container, { kind, suggestions }) {
  const template = container.querySelector(`[data-suggestion-group="${kind}"]`)
  if (!template) return null

  const group = template.cloneNode(true)
  group.classList.remove("hidden")
  group.removeAttribute("data-suggestion-group")
  const rowTemplate = group.querySelector("[data-suggestion-row]")
  const rows = suggestions.map((text) => createCopyWithText(rowTemplate, text))
  rows.forEach((row) => (row.dataset.suggestionKind = kind))
  rowTemplate.replaceWith(...rows)
  return group
}

function visibleSuggestionRows() {
  return [...this.suggestionTilesTarget.querySelectorAll("[data-suggestion-row]:not(.hidden)")]
}

function toggleSuggestions(visible) {
  show([visible ? this.suggestionTilesTarget : this.defaultPanelTarget])
  hide([visible ? this.defaultPanelTarget : this.suggestionTilesTarget])
}

export function parseFiltersFromUrl(pathname, filterName, value) {
  const filters = pathname.split("/").slice(2)
  const filterIndex = filters.findIndex((el) => el === filterName)
  if (filterIndex === -1) return

  const values = filters[filterIndex + 1]

  return values.split("+").some((el) => el === value)
}
